import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./styles/custom.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { ToastContainer } from "react-toastify";

const root = ReactDOM.createRoot(document.getElementById("root"));

window.global = {
  // server_url: "http://192.168.1.17:8000",
  // server_url: "http://117.232.75.164:8040",
  server_url: "https://dcportal.transforma.in:8446",
};

root.render(
  // <React.StrictMode>
  <BrowserRouter basename="/">
    <ToastContainer
      position="top-center"
      autoClose={2000}
      hideProgressBar={false}
      newestOnTop={false}
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
      theme="light"
    />
    <App />
  </BrowserRouter>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
